// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__WgNSD","iconContainer":"styles_iconContainer__Azhri","footerLinkContainer":"styles_footerLinkContainer__FMLza"};